import angular from 'angular';
import { ReorderProductsListModule } from './reorder-products-list/reorder-products-list.module';
import { ReorderProductsService } from './reorder-products.service';
export var ReorderProductsModule = angular
    .module('eeComUiApp.reorderProducts', [
    ReorderProductsListModule
])
    .service('ReorderProductsService', ReorderProductsService)
    .name;
//# sourceMappingURL=reorder-products.module.js.map